import React, { useEffect, FC, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { LayoutPropType } from './types';
import LayoutClient from './LayoutClient';
import { STORE_PATH } from 'types/generals/storePaths';
import { AppState } from 'store';
import { StoreSettingsState } from 'store/ducks/store/storeSettings/types';
import { useSelector } from 'react-redux';

const Layout: FC<LayoutPropType> = ({ children }) => {
  const { pathname } = useLocation();
  const { isMaintenance } = useSelector<AppState, StoreSettingsState>(
    ({ storeSettings }: AppState) => storeSettings,
  );

  const isStore = useMemo(
    () => pathname.includes(STORE_PATH(isMaintenance)),
    [pathname, isMaintenance],
  );

  useEffect(() => {
    if (isStore) {
      const NEW_STORE_LINK = 'https://loja.bibliotecacatolica.com.br/';
      window.location.href = NEW_STORE_LINK;
    }
  }, [isStore]);

  if (isStore) return null;

  return <LayoutClient children={children} />;
};

export default Layout;
